import React from 'react';
import {useStyles} from "./ShowAdditionalPrice.style";
import ShowAdditionalPriceProperties from "./ShowAdditionalPriceProperties";
import clsx from "clsx";
import { CurrencyModule } from '../../../util/Currency';
import { useI18nContext } from '../../../contexts/I18nContext';

const ShowAdditionalPrice: React.FC<ShowAdditionalPriceProperties> = ({
                                                          className = '',
                                                          amount,
                                                          isPercent = false,
                                                          comment = '',
                                                          paymentType,
                                                          light = false
                                                      }) => {
    const i18n = useI18nContext();
    const classes = useStyles(light);

    return (
        <div className={clsx(classes.payment_type_info_container, className)}>
            <div className={classes.info}>
                <div>
                    {!isPercent && CurrencyModule.format(amount)}
                    {isPercent && `${amount} %`}
                </div>
                <div>{comment}</div>
                {paymentType && <div className={classes.paymet_type_container}>{i18n.translate(`PAYMENT_TYPE_${paymentType}`)}</div>}
            </div>
        </div>
    )
}
export default ShowAdditionalPrice;